export function showErrorToolTips(obj, jsonlang) {
    for (var item in obj) {
        var code = obj[item].code;
        var jqelem = obj[item].obj;
        if (!jqelem.hasClass('invalid-input')) jqelem.addClass("invalid-input");
        jqelem = $(document).find('.'+obj[item].code);
        if (jqelem.hasClass('invalid-feedback')) { 
            jqelem.html(jsonlang[code]);
            jqelem.css("opacity", "1");
        }
    }
}

export function clearErrorAssetSearch() {
    var jqelem = $('#searchstring');
    if (jqelem.hasClass('invalid-input')) {
        jqelem.removeClass("invalid-input");
    }
    jqelem = $(document).find('.001');
    if (jqelem.hasClass('invalid-feedback')) { 
        jqelem.css("opacity", "0");
    }
}

export function removeAllErrorToolTips() {
    $('.invalid-input').each(function() {
        $(this).removeClass('invalid-input');
    });
    $('.invalid-feedback').each(function() {
        $('.invalid-feedback').css("opacity", "0");
    });
}

export function markAllInputFieldsRed() {
    $('.input-group-text').each(function() {
        if (!$(this).hasClass("invalid-input"))
            $(this).addClass('invalid-input');
    });
}


